import { Button } from '@/common/ui/button'
import {
	startOfDay,
	endOfDay,
	startOfMonth,
	endOfMonth,
	subDays,
	subMonths,
	format,
} from 'date-fns'

const dateRangeOptions = [
	{
		label: 'ทั้งหมด',
		mobileLabel: 'ทั้งหมด',
		value: 'all',
	},
	{
		label: 'วันนี้',
		mobileLabel: 'วันนี้',
		value: 'today',
	},
	{
		label: 'เมื่อวาน',
		mobileLabel: 'เมื่อวาน',
		value: 'yesterday',
	},
	{
		label: '7 วัน',
		mobileLabel: '7วัน',
		value: '7days',
	},
	{
		label: 'เดือนนี้',
		mobileLabel: 'เดือนนี้',
		value: 'thisMonth',
	},
	{
		label: 'เดือนที่แล้ว',
		mobileLabel: 'เดือนก่อน',
		value: 'lastMonth',
	},
]

type ComparisonDateRangeButtonsProps = {
	selectedRange: string
	onRangeChange: (value: string) => void
	onStartDateChange: (date: string) => void
	onEndDateChange: (date: string) => void
}

export default function ComparisonDateRangeButtons({
	selectedRange,
	onRangeChange,
	onStartDateChange,
	onEndDateChange,
}: ComparisonDateRangeButtonsProps) {
	const handleDateRangeChange = (value: string) => {
		onRangeChange(value)
		const today = new Date()

		switch (value) {
			case 'all': {
				onStartDateChange('')
				onEndDateChange('')
				break
			}
			case 'today': {
				onStartDateChange(format(startOfDay(today), 'yyyy-MM-dd'))
				onEndDateChange(format(endOfDay(today), 'yyyy-MM-dd'))
				break
			}
			case 'yesterday': {
				const targetDate = subDays(today, 1)
				onStartDateChange(format(startOfDay(targetDate), 'yyyy-MM-dd'))
				onEndDateChange(format(endOfDay(targetDate), 'yyyy-MM-dd'))
				break
			}
			case '7days': {
				const start = subDays(today, 6) // -6 because we want to include today
				onStartDateChange(format(startOfDay(start), 'yyyy-MM-dd'))
				onEndDateChange(format(endOfDay(today), 'yyyy-MM-dd'))
				break
			}
			case 'thisMonth': {
				onStartDateChange(format(startOfMonth(today), 'yyyy-MM-dd'))
				onEndDateChange(format(endOfMonth(today), 'yyyy-MM-dd'))
				break
			}
			case 'lastMonth': {
				const targetMonth = subMonths(today, 1)
				onStartDateChange(format(startOfMonth(targetMonth), 'yyyy-MM-dd'))
				onEndDateChange(format(endOfMonth(targetMonth), 'yyyy-MM-dd'))
				break
			}
		}
	}

	return (
		<div className="flex flex-wrap gap-1 sm:gap-2">
			{dateRangeOptions.map((option) => (
				<Button
					key={option.value}
					variant={selectedRange === option.value ? 'default' : 'outline'}
					size="sm"
					onClick={() => handleDateRangeChange(option.value)}
					className="h-8 px-2 text-xs sm:h-9 sm:px-3 sm:text-sm"
				>
					{/* Mobile: Shorter labels */}
					<span className="sm:hidden">{option.mobileLabel}</span>
					{/* Desktop: Full labels */}
					<span className="hidden sm:inline">{option.label}</span>
				</Button>
			))}
		</div>
	)
}
